/**
 * Order-Status Utilities · iter171 (2026-02-27)
 *
 * Zentraler Ort für:
 *  - Deutsche Übersetzungen für ORDER_STATUS und PAYMENT_STATUS
 *  - Farb-Klassen nach User-Vorgabe:
 *      GRÜN  → Erfolgs-States (PAID, SHIPPED, DELIVERED, COMPLETED, PAYMENT_CONFIRMED)
 *      GELB  → In-Arbeit-States (CREATED, AWAITING_SHIPMENT, PAYMENT_PENDING)
 *      BLAU  → Erstattung (REFUNDED, REFUND_PENDING)
 *      ROT   → Abgebrochen (CANCELLED, PAYMENT_CANCELLED, FAILED)
 */

export const ORDER_STATUS_LABELS = {
  CREATED: "Erstellt",
  PAID: "Bezahlt",
  AWAITING_INBOUND: "Eingang erwartet",
  AWAITING_SHIPMENT: "Versand ausstehend",
  INBOUND_RECEIVED: "Eingang bestätigt",
  SHIPPED: "Versendet",
  DELIVERED: "Zugestellt",
  COMPLETED: "Abgeschlossen",
  CANCELLED: "Storniert",
  REFUNDED: "Erstattet",
};

export const PAYMENT_STATUS_LABELS = {
  PAYMENT_PENDING: "Zahlung ausstehend",
  PAYMENT_CONFIRMED: "Bezahlt",
  PAID: "Bezahlt",
  PAYMENT_CANCELLED: "Zahlung storniert",
  PAYMENT_FAILED: "Zahlung fehlgeschlagen",
  REFUND_PENDING: "Erstattung läuft",
  REFUNDED: "Erstattet",
  CREATED: "Angelegt",
};

const COLOR_GREEN = "text-green-700 border-green-200 bg-green-50";
const COLOR_YELLOW = "text-amber-700 border-amber-200 bg-amber-50";
const COLOR_BLUE = "text-blue-700 border-blue-200 bg-blue-50";
const COLOR_RED = "text-red-700 border-red-200 bg-red-50";
const COLOR_GRAY = "text-[#666] border-[#E5E5E5] bg-white";

const GREEN_STATES = new Set(["PAID", "SHIPPED", "DELIVERED", "COMPLETED", "PAYMENT_CONFIRMED", "INBOUND_RECEIVED", "VERIFIED", "APPROVED", "RESOLVED", "LABEL_CREATED", "PUBLISHED", "ACTIVE"]);
const YELLOW_STATES = new Set(["CREATED", "AWAITING_INBOUND", "AWAITING_SHIPMENT", "PAYMENT_PENDING", "PENDING", "UNDER_REVIEW", "NEEDS_REVIEW", "IN_REVIEW", "DRAFT"]);
const BLUE_STATES = new Set(["REFUNDED", "REFUND_PENDING", "DISMISSED"]);
const RED_STATES = new Set(["CANCELLED", "PAYMENT_CANCELLED", "PAYMENT_FAILED", "FAILED", "REJECTED", "REPORTED", "BLOCKED", "REMOVED"]);

// iter172 · Generische deutsche Status-Labels für Admin-Panels
export const ADMIN_STATUS_LABELS = {
  // Bestellungen
  ...ORDER_STATUS_LABELS,
  ...PAYMENT_STATUS_LABELS,
  // Generisch
  PENDING: "Ausstehend",
  APPROVED: "Genehmigt",
  REJECTED: "Abgelehnt",
  VERIFIED: "Verifiziert",
  UNDER_REVIEW: "In Prüfung",
  IN_REVIEW: "In Prüfung",
  NEEDS_REVIEW: "Prüfung nötig",
  RESOLVED: "Gelöst",
  DISMISSED: "Verworfen",
  REPORTED: "Gemeldet",
  BLOCKED: "Gesperrt",
  REMOVED: "Entfernt",
  DRAFT: "Entwurf",
  PUBLISHED: "Veröffentlicht",
  ACTIVE: "Aktiv",
  LABEL_CREATED: "Label erstellt",
  // Shipment
  IN_TRANSIT: "In Zustellung",
  OUT_FOR_DELIVERY: "In Auslieferung",
  RETURNED: "Zurückgesendet",
};

export function adminStatusLabel(status) {
  if (!status) return "—";
  return ADMIN_STATUS_LABELS[status] || status;
}

export function orderStatusColor(status) {
  if (!status) return COLOR_GRAY;
  const s = String(status).toUpperCase();
  if (GREEN_STATES.has(s)) return COLOR_GREEN;
  if (YELLOW_STATES.has(s)) return COLOR_YELLOW;
  if (BLUE_STATES.has(s)) return COLOR_BLUE;
  if (RED_STATES.has(s)) return COLOR_RED;
  return COLOR_GRAY;
}

export function orderStatusLabel(status) {
  if (!status) return "—";
  return ORDER_STATUS_LABELS[status] || status;
}

export function paymentStatusLabel(status) {
  if (!status) return "—";
  return PAYMENT_STATUS_LABELS[status] || status;
}
